import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getContractTypeListing = async (filterType) => {
	let response = null;
	let errorMessage = null;

	try {
		const params = { lookupHdrId: "CONTRACT_TYPE", sort: "seq,asc" };
		const res = await api.get.general.list(params);
		let content = res.map(({ lookupTitle, lookupValue, ...o }) => ({ label: lookupTitle, value: lookupValue, ...o }));

		if (filterType) content = content.filter((o) => o.value === filterType);

		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getContractTypeListing;
